import { render, staticRenderFns } from "./ModificaContenuti.vue?vue&type=template&id=5a8a05ec&scoped=true&"
import script from "./ModificaContenuti.vue?vue&type=script&lang=js&"
export * from "./ModificaContenuti.vue?vue&type=script&lang=js&"
import style0 from "./ModificaContenuti.vue?vue&type=style&index=0&id=5a8a05ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a05ec",
  null
  
)

export default component.exports